import { useLabels } from 'wsm-common-data';
import { safeGetItem } from '../utilities/browserStorage';
import { ORIGINAL_SEARCH_TERM_KEY } from '../global-constants';

const SpellcheckMsg = () => {
	const label = useLabels().get('SEARCH_INSTEAD_FOR');
	const originalSearchTerm = safeGetItem(
		'localStorage',
		ORIGINAL_SEARCH_TERM_KEY
	);

	const setOriginalSearchTerm = () => {
		window.DDC.InvData.setOriginalSearchTerm();
	};
	return (
		<div>
			{label}&nbsp;
			<button
				type="button"
				className="text-link"
				onClick={() => setOriginalSearchTerm()}
			>
				&quot;{originalSearchTerm}&quot;
			</button>
		</div>
	);
};

export default SpellcheckMsg;
